import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url(assets/media/illustrations/sketchy-1/14.png"}
}
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_4 = { class: "w-lg-550px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = {
  class: "form w-100",
  novalidate: "novalidate",
  id: "kt_new_password_form"
}
const _hoisted_6 = { class: "text-center mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Setup New Password", -1)
const _hoisted_8 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Already have reset your password ? ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Sign in here")
const _hoisted_11 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Password", -1)
const _hoisted_14 = { class: "position-relative mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2",
  "data-kt-password-meter-control": "visibility"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-slash fs-2" }),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye fs-2 d-none" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Use 8 or more characters with a mix of letters, numbers & symbols.", -1)
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Confirm Password", -1)
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_router_link, {
                  to: "/sign-in",
                  class: "link-primary fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control form-control-lg form-control-solid",
                    type: "password",
                    placeholder: "",
                    name: "password",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
                    autocomplete: "off"
                  }, null, 512), [
                    [_vModelText, _ctx.newPassword]
                  ]),
                  _hoisted_15
                ])
              ]),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg form-control-solid",
                type: "password",
                placeholder: "",
                name: "confirm-password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                autocomplete: "off"
              }, null, 512), [
                [_vModelText, _ctx.confirmPassword]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                id: "kt_new_password_submit",
                class: "btn btn-lg btn-primary fw-bolder",
                name: "submitButton",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmitForgotPassword && _ctx.onSubmitForgotPassword(...args)))
              }, _hoisted_22)
            ])
          ])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}